var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SplitPane",
    [
      _c(
        "ScrollPane",
        { attrs: { slot: "left" }, slot: "left" },
        [
          _c("ActionHeader", { attrs: { slot: "header" }, slot: "header" }, [
            _c(
              "div",
              { staticClass: "search" },
              [
                _c("VueIcon", { attrs: { icon: "search" } }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.filter,
                      expression: "filter",
                      modifiers: { trim: true }
                    }
                  ],
                  attrs: { placeholder: "Filter components" },
                  domProps: { value: _vm.filter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.filter = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ],
              1
            )
          ]),
          _vm.filteredItems
            ? _c("RecycleScroller", {
                staticClass: "components",
                class: {
                  "high-density": _vm.highDensity
                },
                attrs: {
                  slot: "scroll",
                  items: _vm.filteredItems,
                  "item-size": _vm.highDensity ? 22 : 34
                },
                slot: "scroll",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var entry = ref.item
                        var index = ref.index
                        var active = ref.active
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "component selectable-item",
                              class: {
                                selected: _vm.selectedEntry === entry
                              },
                              attrs: {
                                "data-active": active,
                                "data-index": index
                              },
                              on: {
                                click: function($event) {
                                  _vm.selectedEntry = entry
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "name" }, [
                                _vm._v(
                                  "\n            <" +
                                    _vm._s(_vm.getComponentName(entry)) +
                                    ">\n          "
                                )
                              ]),
                              _c("div", { staticClass: "total-time" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(Math.round(entry.totalTime)) +
                                    " ms\n          "
                                )
                              ]),
                              _c("div", { staticClass: "bar-wrapper" }, [
                                _c("div", {
                                  staticClass: "bar",
                                  style: _vm.getTotalTimeBarStyle(entry)
                                })
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3935340999
                )
              })
            : _vm._e()
        ],
        1
      ),
      _c("ComponentRenderDetails", {
        attrs: { slot: "right", entry: _vm.selectedEntry },
        slot: "right"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }